import * as React from 'react';

const Linkedin = ({
  fill = '#4A4F4A',
  width = '24',
  height = '24'
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 19.6862C0 9.19275 8.50659 0.686157 19 0.686157C29.4934 0.686157 38 9.19275 38 19.6862C38 30.1796 29.4934 38.6862 19 38.6862C8.50659 38.6862 0 30.1796 0 19.6862Z" fill="#616161" />
    <path d="M26.6678 10.6862H11.3292C10.5944 10.6862 10.0002 11.2636 10.0002 11.9776V27.3098C10.0002 28.0238 10.5944 28.6047 11.3292 28.6047H26.6678C27.4026 28.6047 28.0002 28.0238 28.0002 27.3133V11.9776C28.0002 11.2636 27.4026 10.6862 26.6678 10.6862ZM15.3405 25.9554H12.6686V17.4021H15.3405V25.9554ZM14.0045 16.2367C13.1467 16.2367 12.4542 15.5473 12.4542 14.6968C12.4542 13.8464 13.1467 13.157 14.0045 13.157C14.8588 13.157 15.5514 13.8464 15.5514 14.6968C15.5514 15.5438 14.8588 16.2367 14.0045 16.2367ZM25.3389 25.9554H22.6706V21.7978C22.6706 20.8074 22.653 19.53 21.2819 19.53C19.8932 19.53 19.6823 20.6114 19.6823 21.7278V25.9554H17.0174V17.4021H19.5768V18.571H19.612C19.967 17.8991 20.8389 17.1886 22.1362 17.1886C24.8397 17.1886 25.3389 18.9595 25.3389 21.2623V25.9554Z" fill="#EAEAEA" />
  </svg>
);

export default Linkedin;
